import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        await refreshUser();
        navigate('/contact', { state: { user: data }, replace: true });
      } catch {
        navigate('/login');
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-[#F3F4F6] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#002FA7] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-sm text-[#4B5563]">Signing you in...</p>
      </div>
    </div>
  );
}
